export const WHATSAPP_NUMBER = "601161255738"; // International format for wa.me (011-6125-5738)
export const WHATSAPP_DISPLAY = "+60 11-6125 5738";
export const TIKTOK_HANDLE = "sangkarmurah_";
export const TIKTOK_URL = "https://www.tiktok.com/@sangkarmurah_?_r=1&_t=ZS-97M5xDq8ryP";

export const buildWhatsAppOrderUrl = (productName, productImage) => {
  const productLine = productName
    ? `Saya berminat dengan *${productName}*.${productImage ? `\n${productImage}` : ""}\n\n`
    : "";

  const text = productName
    ? `Hai Sangkar Murah Enterprise!

Saya dari _______________ (bandar/negeri).

${productLine}Boleh saya tahu lebih lanjut?

Terima kasih!`
    : `Hai Sangkar Murah Enterprise!

Saya dari _______________ (bandar/negeri).

Boleh saya tahu lebih lanjut tentang tempahan sangkar kucing?

Terima kasih!`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};
